export const regexZipCode = /^[0-9]{5}(?:-[0-9]{4})?$/;
